import { Card } from '@/components/ui/card'
import { AlertCircle } from 'lucide-react'
import { EncuestaLayout } from '../../components/public/EncuestaLayout'

export function YaRespondidaPage() {
  return (
    <EncuestaLayout>
      <Card className="p-8 md:p-12 text-center space-y-4">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-yellow-100">
          <AlertCircle className="h-8 w-8 text-yellow-600" />
        </div>
        <h1 className="text-xl font-bold text-gray-800">Ya respondiste esta encuesta</h1>
        <p className="text-gray-500 text-sm">
          Nuestros registros indican que ya completaste esta encuesta anteriormente.
          Solo se permite una respuesta por persona.
        </p>
      </Card>
    </EncuestaLayout>
  )
}
